<div class="modal-loja-lado">
  <div class="header">
    <h4>
      <i class="fe-server ml-1"> </i> Servidor Impressão -
      <span  class="badge badge-blue">{{servidorExecutor.obtenhaNome()}}</span> </h4>

          <div class="servidor-status"  >
              <span class="badge badge-success" *ngIf="servidorExecutor.conectado()">

                Conectado
              </span>

              <span class="badge badge-danger" *ngIf="!servidorExecutor.conectado()">
                Desconectado
              </span>
          </div>
          <!-- Status quando não é servidor -->
          <div class="servidor-status" *ngIf="false">
              <span class="badge badge-muted">
                <i class="fe-monitor"></i>
                Cliente
              </span>
          </div>

      <button class="btn btn-link btn-fechar" (click)="fechar()">
        <i class="fas fa-times" style="    font-size: 20px;"></i>
      </button>
  </div>

  <div class="content">
     <ng-container *ngIf="servidorExecutor.servidorRegistrado">
       <app-gerenciador-jobs-impressao></app-gerenciador-jobs-impressao>
     </ng-container>

     <div class="alert alert-danger" *ngIf="!servidorExecutor.servidorRegistrado">
          Nenhum servidor impressão configurado
     </div>
  </div>

</div>
